module.exports = __webpack_public_path__ + "img/UI_common_title_help_01_en_4f74d488b.png";